module.exports = [
	{
		"country": "Sweden",
		"percentage": 1.4,
		"fill": "url(#se-flag-sm)"
	},
	{
		"country": "United Arab Emirates",
		"percentage": 1.09,
		"fill": "url(#ae-flag-sm)"
	},
	{
		"country": "Norway",
		"percentage": 1.05,
		"fill": "url(#no-flag-sm)"
	},
	{
		"country": "Luxembourg",
		"percentage": 0.93,
		"fill": "url(#lu-flag-sm)"
	},
	{
		"country": "Denmark",
		"percentage": 0.85,
		"fill": "url(#dk-flag-sm)"
	},
	{
		"country": "Netherlands",
		"percentage": 0.76,
		"fill": "url(#nl-flag-sm)"
	},
	{
		"country": "United Kingdom",
		"percentage": 0.71,
		"fill": "url(#gb-flag-sm)"
	},
	{
		"country": "Finland",
		"percentage": 0.56,
		"fill": "url(#fi-flag-sm)"
	},
	{
		"country": "Turkey",
		"percentage": 0.54,
		"fill": "url(#tr-flag-sm)"
	},
	{
		"country": "Switzerland",
		"percentage": 0.52,
		"fill": "url(#ch-flag-sm)"
	},
	{
		"country": "Germany",
		"percentage": 0.52,
		"fill": "url(#de-flag-sm)"
	},
	{
		"country": "Belgium",
		"percentage": 0.42,
		"fill": "url(#be-flag-sm)"
	},
	{
		"country": "France",
		"percentage": 0.37,
		"fill": "url(#fr-flag-sm)"
	},
	{
		"country": "Ireland",
		"percentage": 0.36,
		"fill": "url(#ie-flag-sm)"
	},
	{
		"country": "Austria",
		"percentage": 0.32,
		"fill": "url(#at-flag-sm)"
	},
	{
		"country": "Canada",
		"percentage": 0.28,
		"fill": "url(#ca-flag-sm)"
	},
	{
		"country": "New Zealand",
		"percentage": 0.27,
		"fill": "url(#nz-flag-sm)"
	},
	{
		"country": "Australia",
		"percentage": 0.27,
		"fill": "url(#au-flag-sm)"
	},
	{
		"country": "Iceland",
		"percentage": 0.24,
		"fill": "url(#is-flag-sm)"
	},
	{
		"country": "Japan",
		"percentage": 0.22,
		"fill": "url(#jp-flag-sm)"
	},
	{
		"country": "Italy",
		"percentage": 0.21,
		"fill": "url(#it-flag-sm)"
	},
	{
		"country": "United States",
		"percentage": 0.17,
		"fill": "url(#us-flag-sm)"
	},
	{
		"country": "Portugal",
		"percentage": 0.16,
		"fill": "url(#pt-flag-sm)"
	},
	{
		"country": "Slovenia",
		"percentage": 0.15,
		"fill": "url(#si-flag-sm)"
	},
	{
		"country": "Malta",
		"percentage": 0.15,
		"fill": "url(#mt-flag-sm)"
	},
	{
		"country": "Estonia",
		"percentage": 0.15,
		"fill": "url(#ee-flag-sm)"
	},
	{
		"country": "Greece",
		"percentage": 0.14,
		"fill": "url(#gr-flag-sm)"
	},
	{
		"country": "South Korea",
		"percentage": 0.14,
		"fill": "url(#kr-flag-sm)"
	},
	{
		"country": "Spain",
		"percentage": 0.13,
		"fill": "url(#es-flag-sm)"
	},
	{
		"country": "Hungary",
		"percentage": 0.13,
		"fill": "url(#hu-flag-sm)"
	},
	{
		"country": "Czech Republic",
		"percentage": 0.12,
		"fill": "url(#cz-flag-sm)"
	},
	{
		"country": "Lithuania",
		"percentage": 0.11,
		"fill": "url(#lt-flag-sm)"
	},
	{
		"country": "Slovak Republic",
		"percentage": 0.1,
		"fill": "url(#sk-flag-sm)"
	},
	{
		"country": "Poland",
		"percentage": 0.1,
		"fill": "url(#pl-flag-sm)"
	},
	{
		"country": "Latvia",
		"percentage": 0.09,
		"fill": "url(#lv-flag-sm)"
	},
	{
		"country": "Israel",
		"percentage": 0.07,
		"fill": "url(#il-flag-sm)"
	},
	{
		"country": "Russia",
		"percentage": 0.06,
		"fill": "url(#ru-flag-sm)"
	}
];


//////////////////
// WEBPACK FOOTER
// ./src/Blog/DataIsBeautiful/developmentAidPercentageOfGdp.json
// module id = 298
// module chunks = 0